<template>
  <div class="pop-dim">
    <div class="pop-wrap">
        <img src="@/assets/images/logo.svg" alt="">

        <h2 v-if="type == 'privacy_checkbox'">개인정보 수집 및 이용 동의</h2>
        <h2 v-if="type == 'third_checkbox'">제 3자 정보제공 동의</h2>
        <div class="txt-wrap">
          <pre>{{terms}}</pre>
        </div>

        <div class="btn-position">
            <button-item :btnText="'읽고 동의하였음'" :btnClass="'pop-information'" @click="onClickAgree"/>
        </div>
        <div class="pop-close" @click="onClickCancel"></div>
    </div>
  </div>
</template>

<script>
import ButtonItem from '@/components/ui/button'

export default {
  name: 'InformantionLayer',
  components: {
    ButtonItem
  },
  props: [
    'type',
    'terms'
  ],
  methods: {
    onClickCancel () {
      this.$close(false)
    },
    onClickAgree () {
      this.$close(true)
    }
  },
  destroyed () {
    this.$close(false)
  }
}
</script>

<style lang="scss" scoped>
.pop-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 640px;
  height: 410px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 30px;
  &>img {
      display: none;
  }
  h2 {
    color: #444;
    margin: 30px 0 14px;
    font-size: 15px;
    font-weight: 500;
    color: #2f2f2f;
  }
  .txt-wrap {
    width: 580px;
    height: 290px;
    padding: 20px 30px 20px 20px;
    box-sizing: border-box;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    font-size: 13px;
    line-height: 1.54;
    color: #444;
    overflow-y: auto;
    margin-bottom: 12px;
    ::v-deep pre {
      white-space: -moz-pre-wrap;
      /* Mozilla, supported since 1999 */
      white-space: -pre-wrap; /* Opera */
      white-space: -o-pre-wrap; /* Opera */
      white-space: pre-wrap;
      /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
      word-wrap: break-word; /* IE 5.5+ */
    }
  }
  .btn-position {text-align: center;}
  .pop-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 10px;
    background: url('../../assets/images/icon-layer-close.svg') no-repeat center;
    cursor: pointer;
  }
}

@media all and (max-width: 768px) {
    .pop-wrap {
        width: 100%;
        height: 100%;
        border-radius: 0px;
        box-sizing: border-box;
        padding: 0 20px;
        background: #F4F4F1;
        overflow-y: auto;
        &>img {
            display: block;
            margin-top: 20px;
        }
        h2 {
            margin: 50px 0 30px;
            font-size: 18px;
            font-weight: 500;
            line-height: 0.83;
            color: #2f2f2f;
        }
        .txt-wrap {
            width: 100%;
            height: auto;
            padding: 0;
            box-sizing: border-box;
            border-radius: 5px;
            border: none;
            background-color: none;
            font-size: 13px;
            line-height: 1.54;
            color: #444;
            overflow-y: auto;
            margin-bottom: 40px;
        }

        .btn-position {
            margin-bottom: 20px;
        }
        .pop-close {
            right: 20px;
            top: 20px;
            background: url('../../assets/images/icon-layer-close-m.svg') no-repeat center;
        }
    }

}
</style>
